export default {
  init() {
    // JavaScript to be fired on the home page
    // Masthead Slider
    var $mastheadPromos = $('.masthead-promos__container');
    var $mastheadPromo = $('.masthead-promos-control');
    var activeClass = 'masthead-promos-control--active';
    $mastheadPromos.slick({
        autoplay: true,
        autoplaySpeed: 9000,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        dots: false,
        arrows: false,
        fade: true,
        mobileFirst: true,
        rows: 0,
    });

    // If there are slide controls (more than one slide controlled in php)
    if ($mastheadPromo.length) {

        var $currentControl = $mastheadPromo.first();
        // Adds current-control class to first control
        $currentControl.addClass(activeClass);

        
        // Listens on each control
        $mastheadPromo.each(function(){
            var $this = $(this);
            var index = $this.data('index');
            var mouseEvent;
            // On a control hover or click (depending on screen width)
            if ($(window).outerWidth() > 768) {
                mouseEvent = 'mouseover';
            } else {
                mouseEvent = 'click';
            }
            $this.on(mouseEvent, function(e){
                // Don't have control click go to link on mobile
                if ($(window).outerWidth() <= 768) {
                    e.preventDefault();
                } 
                // Remove all current-control classes and add it to clicked control
                $mastheadPromo.removeClass(activeClass);
                $(this).addClass(activeClass);
                
                // Hook into Slick's method to go to corresponding slide
                $mastheadPromos.slick('slickGoTo', index);
                
            });

        });

        // Moves magic line when Slick auto moves slides
        $mastheadPromos.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            // Remove all current-control classes and add it to clicked control
            $mastheadPromo.removeClass(activeClass);
            $(".masthead-promos-control[data-index='" + nextSlide + "']").addClass(activeClass);
            //   $currentControlWidth = $('.current-control').outerWidth();
            //   $currentControlLeft = $('.current-control').position().left;

        });
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js